import React, { Component, useState } from 'react';
import { Ref } from './App';

export function NavBar(props) {
  let [open, setOpen] = useState(false);

  async function logOut() {
    const res = await window.fetch("/logout");
    Object.values(Ref.timers).forEach(f => clearInterval(f));
    Ref.timers = {};
    props.setLogin("");
  }

  return (
    <div className="navbar navbar-inverse navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button data-target=".navbar-collapse" data-toggle="collapse" className="navbar-toggle" type="button">
            <span className="clip-list-2"></span>
          </button>
          <a className="navbar-brand logo" href="/">
            <img src="/img/c-portal.svg" />
          </a>
        </div>
        <div className="navbar-tools">
          <ul className="nav navbar-right">
            <li className="dropdown">
              <ul className="dropdown-menu notifications">
                <li>
                  <span className="dropdown-menu-title"> Upozornění</span>
                </li>
                <li>
                  <div className="drop-down-wrapper">
                    <ul id="notifications-list"></ul>
                  </div>
                </li>
              </ul>
            </li>
            <li className="dropdown">
              <ul className="dropdown-menu posts">
                <li>
                  <span className="dropdown-menu-title"> Máte <span className="count-messages"></span> zpráv</span>
                </li>
                <li>
                  <div className="drop-down-wrapper">
                    <ul id="messages-list"></ul>
                  </div>
                </li>
              </ul>
            </li>
            <li className={"dropdown current-user" + (open ? " open" : "")} onClick={() => setOpen(!open)}>
              <a data-toggle="dropdown" className="dropdown-toggle" href="#">
                <img
                  src="/img/ariscat.png"
                  className="circle-img" alt="" id="ariscat-user-picture" width="30" height="30" />
                <span className="username" id="ariscat-username">{props.userName}</span>
                <i className="clip-chevron-down"></i>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a id="user-logout" onClick={() => logOut()}>
                    <i className="clip-exit"></i>&nbsp;Odhlásit se
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export function Footer() {
  return (
    <div className="footer clearfix">
      <div className="footer-inner">
        &copy; 2020 CATHEDRAL Software s.r.o.
      </div>
      <div className="footer-items">
        <span className="go-top"><i className="fa fa-chevron-up"></i></span>
      </div>
    </div>
  );
}

export function TD({ caption }) { 
  return (
      <td className="td">{caption}</td>
  );                    
}


export function Main2() { 
  return (
    <div className="main-container">
        <div className="main-navigation navbar-collapse collapse">
            <ul className="main-navigation-menu">
                <li className=""><a href="/"><i className="fa fa-list"></i><span
                            className="title">Aktivity</span><span className="selected"></span></a></li>
                <li className="active open"><a href="/ukoly"><i className="fa fa-list"></i><span
                            className="title">Úkoly</span><span className="selected"></span></a></li>
            </ul>
        </div>
        <div className="main-content">
            <div className="panel-heading">Úkoly<div className="panel-tools bigger">
                    <div className="btn btn-sm btn-success new-item"><i className="fa fa-plus"></i> Nový</div>
                </div>
            </div>
            <div className="panel-body">
                <div className="table-content">
                    <div className="dataTables_wrapper dt-bootstrap no-footer">
                        <div className="dataTables_length col-sm-6"><label>Zobrazit 
                                <select
                                    className="form-control input-sm m-wrap small">
                                    <option value="2">2</option>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select> záznamů</label></div>
                        <div className="dataTables_filter">
                          <label></label>
                        </div>
                        <table
                            className="table table-striped display responsive table-bordered table-hover dataTable no-footer dtr-inline">
                            <thead>
                                <tr role="row">
                                    <th className="sorting">ID</th>
                                    <th className="sorting">Číslo</th>
                                    <th className="sorting">Název</th>
                                    <th className="sorting">%</th>
                                    <th className="sorting">Priorita</th>
                                    <th className="sorting">Zahájení</th>
                                    <th className="sorting">Ukončení</th>
                                    <th className="sorting">Akce</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="id">1</td>
                                    <td className="cislo">123</td>
                                    <td className="nazev">Programovani ArisCAT</td>
                                    <td className="procent">55</td>
                                    <td className="priorita">Střední</td>
                                    <td className="zahajeni">1.1.2020</td>
                                    <td className="ukonceni">30.12.2022</td>
                                    <td className="actions">
                                        <div className="btn btn-warning btn-sm"><i className="fa fa-edit"></i></div>
                                        <div className="btn btn-danger dropdown-toggle btn-sm itemList"><i
                                                className="fa fa-trash-o"></i></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="id">2</td>
                                    <td className="cislo">123</td>
                                    <td className="nazev">Úkol</td>
                                    <td className="procent">55</td>
                                    <td className="priorita">Střední</td>
                                    <td className="zahajeni">1.1.2020</td>
                                    <td className="ukonceni">30.12.2022</td>
                                    <td className="actions">
                                        <div className="btn btn-warning btn-sm"><i className="fa fa-edit"></i></div>
                                        <div className="btn btn-danger dropdown-toggle btn-sm itemList"><i
                                                className="fa fa-trash-o"></i></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="id">3</td>
                                    <td className="cislo">123</td>
                                    <td className="nazev">Úkol</td>
                                    <td className="procent">55</td>
                                    <td className="priorita">Střední</td>
                                    <td className="zahajeni">1.1.2020</td>
                                    <td className="ukonceni">30.12.2022</td>
                                    <td className="actions">
                                        <div className="btn btn-warning btn-sm"><i className="fa fa-edit"></i></div>
                                        <div className="btn btn-danger dropdown-toggle btn-sm itemList"><i
                                                className="fa fa-trash-o"></i></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="id">4</td>
                                    <td className="cislo">123</td>
                                    <td className="nazev">Úkol</td>
                                    <td className="procent">55</td>
                                    <td className="priorita">Střední</td>
                                    <td className="zahajeni">1.1.2020</td>
                                    <td className="ukonceni">30.12.2022</td>
                                    <td className="actions">
                                        <div className="btn btn-warning btn-sm"><i className="fa fa-edit"></i></div>
                                        <div className="btn btn-danger dropdown-toggle btn-sm itemList"><i
                                                className="fa fa-trash-o"></i></div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <div className="dataTables_info">Zobrazeno 1 do 4 z 60 záznamů</div>
                        <div className="dataTables_paginate paging_simple_numbers">
                            <ul className="pagination">
                                <li className="paginate_button next"><a>Předchozí</a></li>
                                <li className="paginate_button active"><a>1</a></li>
                                <li className="paginate_button"><a>2</a></li>
                                <li className="paginate_button"><a>3</a></li>
                                <li className="paginate_button"><a>...</a></li>
                                <li className="paginate_button"><a>6</a></li>
                                <li className="paginate_button next"><a>Další</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );                    
}
